import { createSlice } from "@reduxjs/toolkit"


const initialState = {
    currentCountry: "India",
    refreshCountry: true,
    countryNames: [],
}

const countrySlice = createSlice({
    name: 'countryDropDown',
    initialState,
    reducers: {
        setSelectedCountry(state, action) {
            state.currentCountry = action?.payload
        },
        setRefreshCountry(state, action) {
            state.refreshCountry = action?.payload
        },
        setCountryNames(state, action) {
            state.countryNames = action?.payload
        },
        clearCountry(state, action) {
            return initialState
        }
    }
})

export const countryActions = countrySlice.actions

export default countrySlice